import { createQuery } from "react-query-kit";

import type { IBalance } from "./types";

import type { AxiosError, IApiResponse, IAxiosFn } from "@api/types";
import { axiosClient } from "@/api/clients";

const key = "wallet";

type IResponse = IApiResponse<IBalance>;
export type IVariables = "";

// TODO add table filters
const getBalance: IAxiosFn<IVariables, IResponse> = async (params, signal) => {
  const { data } = await axiosClient.get("/wallets/balance", {
    params,
    signal,
  });

  return data;
};

export const useBalance = createQuery<IResponse, IVariables, AxiosError>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getBalance(variables, signal),
});
